import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FormField,
  AutocompleteStyle,
  AutocompleteResultStyle,
  AutocompleteSearch,
  AutocompleteWrapper,
  IconsWrapper,
  PhoneInputPanel
} from "./styles";
import { Link, useHistory } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import { Modal, Button, Form } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import { db } from "../../services/firebase/Config";
import { ContactsOutlined } from "@material-ui/icons";
import axios from "axios";

export function Autocomplete(props) {
  const inputRef = useRef();
  const { query, setQuery, filteredItems, clearFilteredItems, loading } =
    props.useSearchItems();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const sesion = useSelector((state) => state.sesion);
  const empresa = useSelector((state) => state.empresa);
  const urlLink = `${process.env.REACT_APP_APP_PACIENTE_URL}` || "http://pac.sysdent.net"
  const endpoint = `${process.env.REACT_APP_API_URL}`
  const { addToast } = useToasts();

  const slugify = (text) => text.toString().toLowerCase().trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-');

  React.useEffect(() => {
    inputRef.current.focus();
  }, [])

  function handleClickItem(item) {
    clearFilteredItems();
    setQuery("");
    props.onSelected(item);
  }

  function handleOpenModal() {
    setIsModalOpen(true);
  }

  function handleCloseModal() {
    setIsModalOpen(false);
  }

  function handleSavePhoneNumber() {
    if (phoneNumber.length !== 9 || !/^\d+$/.test(phoneNumber)) {
      alert("El número de teléfono debe tener 9 dígitos");
      return;
    }

    const payload = {
      purpose: 'NEW_PATIENT_ONBOARDING',
      empresaId: sesion.usuario.empresaId,
      seed: phoneNumber,
      expiresAt: null
    };

    let razonSocial = "Sysdent";

    axios.post(`${endpoint}/api/v1/pacientes/generar-invitacion`, payload, {
      headers: {
        'Authorization': `Bearer ${sesion.usuario.accessToken}`
      }
    })
      .then(response => {
        if (response.status !== 201) {
          alert(`Error al obtener el token: ${response.status}`);
          throw new Error(`Error al obtener el token: ${response.status}`);
        }

        const token = response.data.tokenId;
        const slug = empresa.slug || slugify(empresa.razonSocial || "clinica");

        const url = `${urlLink}/${slug}?token=${token}`;

        const mensaje = `¡Bienvenido a ${empresa.razonSocial || "nuestra clínica"}! Ingresa tus datos aquí: ${url}`;

        const whatsappLink = `https://wa.me/51${phoneNumber}?text=${encodeURIComponent(mensaje)}`;
        window.open(whatsappLink, '_blank');

        handleCloseModal();
      })
      .catch(error => {
        console.error(error);
        addToast(error.message || "Error al generar invitación", { appearance: "error" });
      });
  }
  return (
    <AutocompleteWrapper>
      <AutocompleteStyle>
        <AutocompleteSearch>
          <FormField
            ref={inputRef}
            type="text"
            placeholder="Buscar Paciente"
            onChange={(e) => setQuery(e.target.value)}
            value={query}
          ></FormField>
          {filteredItems.length > 0 && (
            <AutocompleteResultStyle>
              {filteredItems.map((item) => (
                <li className="liStyle" key={item.id} onClick={() => handleClickItem(item)}>
                  {props.toString(item)}
                </li>
              ))}
            </AutocompleteResultStyle>
          )}
        </AutocompleteSearch>
        <IconsWrapper>
          <Tooltip
            placement="top"
            title="Agregar Paciente"
          >
            <Link to="/paciente/datos">
              <img
                src={require("../../img/azul_nuevo_paciente.png")}
                alt="add new patient icon"
              />
            </Link>
          </Tooltip>
          <Tooltip
            placement="top"
            title="Invitar Paciente"
          >
            <span style={{ position: "relative", display: "inline-block" }}>
              <img
                src={require("../../img/mail-send.png")}
                alt="add new patient icon"
                onClick={handleOpenModal}
                style={{ cursor: "pointer" }}
              />
              {isModalOpen && (
                <PhoneInputPanel>
                  <Form>
                    <Form.Group controlId="formPhoneNumber">

                      <Form.Control
                        type="text"
                        placeholder="Teléfono"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        autoFocus
                      />
                    </Form.Group>
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 12 }}>
                      <Button variant="secondary" size="sm" onClick={handleCloseModal}>
                        Cancelar
                      </Button>
                      <Button variant="primary" size="sm" onClick={handleSavePhoneNumber}>
                        Enviar
                      </Button>
                    </div>
                  </Form>
                </PhoneInputPanel>
              )}
            </span>
          </Tooltip>
        </IconsWrapper>
      </AutocompleteStyle>
    </AutocompleteWrapper>
  );
}